export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите счет оферента"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счет оферента"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}